/* global document, MutationObserver, window */

/**
 * Mobile menu behaviors.
 */

const mainMenu = ($) => {

  // Injects the site logo and close button into the first panel title area.
  const injectHeaderElements = () => {
    const mmPanel = document.getElementById('mm-1');
    const mmTitle = mmPanel?.querySelector('.mm-navbar__title');

    if (mmTitle && !mmTitle.querySelector('.navbar-brand')) {
      // Create the logo element
      const logoLink = document.createElement('a');
      logoLink.href = '/';
      logoLink.className = 'navbar-brand';

      const logoImg = document.createElement('img');
      logoImg.src = '/themes/custom/ilcm_theme/logo.svg';
      logoImg.alt = 'Site Logo';

      logoLink.appendChild(logoImg);

      // Create the close button
      const closeBtn = document.createElement('button');
      closeBtn.className = 'mm-close';
      closeBtn.setAttribute('aria-label', 'Close menu');
      closeBtn.innerHTML = 'Close menu';

      // Append both to the navbar title
      mmTitle.appendChild(logoLink);
      mmTitle.appendChild(closeBtn);

      // Add event listener to close menu
      closeBtn.addEventListener('click', () => {
        const mmApi = document.querySelector('#off-canvas')?.mmApi;
        mmApi?.close?.(document.getElementById('off-canvas'));
      });
    }
  };

  // Run logo.close button once on init
  injectHeaderElements();

}

export default mainMenu;
